<template>
  <div :class="classes" v-loading="customerLoading">
    <pt-page-title :title="isEdit?'编辑'+ '优惠劵':'新建' + '优惠劵'"></pt-page-title>
    <pt-sub-title title="优惠劵信息"></pt-sub-title>
    <table :class="$style['coupon-form-table']">
         <pt-form-list-item label="优惠劵名称：" :required="true">
            <wt-input data-vv-as="优惠劵名称" name="name"  v-validate="'required'" v-model="formValue.couponData.name"  :class="$style['coupon-table-name']"></wt-input>
        </pt-form-list-item>
         <pt-form-list-item label="使用形式：" :required="true">
           <wt-radio :radios="usedType" data-vv-as="使用形式" v-validate="'required'" v-model="formValue.couponData.usedType"></wt-radio>
        </pt-form-list-item>
        <pt-form-list-item label="发放数量:" :required="true" v-if="needAmountOffline">
            <wt-input data-vv-as="发放数量" name="name" type="number"  v-validate="'required|numeric|min_value:1'" v-model="formValue.amount"  :class="$style['coupon-table-name']"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="优惠劵形式：" :required="true">
            <template>
                <wt-radio :radios="discountTypes" v-model="formValue.couponData.discountType" data-vv-as="优惠劵形式" name="name"  v-validate="'required'"></wt-radio>
            </template>
        </pt-form-list-item>
        <pt-form-list-item :label="currentDiscountLabel + '：'" :required="true">
            <template>
                <wt-input :class="$style['number-input-price']" v-model="couponDiscount" :data-vv-as="currentDiscountLabel" name="name" type="number" :min="0" v-validate="'required|' + (formValue.couponData.discountType=='FIXED_AMOUNT' ? 'numeric|min_value:0' : 'decimal:1|discount')"><el-button slot="append">{{formValue.couponData.discountType=='FIXED_AMOUNT'?'元':"折"}}</el-button></wt-input>
                <div v-if="formValue.couponData.discountType=='PROPORTION'" style="color:red;font-size:14px;">折扣应大于0且小于10，商品最终价格为商品原价*折扣/10</div>
            </template>
        </pt-form-list-item>
         <pt-form-list-item label="使用门槛：">
            <div :class="$style['carpet-content']">满<wt-input type="number" name="name"  v-model="formValue.couponData.thresholdOf_amount" :class="$style['coupon-table-name']"></wt-input>元可使用</div>
        </pt-form-list-item>
        <template v-if="needSelectGoods">
        <pt-form-list-item label="适用商品归属：" :required="true">
            <wt-radio :radios="goodsBelongLabel" data-vv-as="适用商品归属" v-validate="'required'" v-model="couponBelong"></wt-radio>
        </pt-form-list-item>
        <!-- <pt-form-list-item label="适用商品分组:">
            <wt-selector :options="groupList" :props="{value:'id',label:'name'}" :multiple="true" v-model="formValue.couponData.goodsGroupIds"></wt-selector>
        </pt-form-list-item> -->
        <pt-form-list-item label="适用商品：" v-if="canSelectGoods" >
            <el-button type="primary" plain :class="$style['select-concessions-button']" @click="selectGoods">点击选择商品</el-button>
            <span style="color:red;padding-left:10px">{{allGoodsNotice}}</span>
            <div class="page-background" v-if="goods_list&&goods_list.length>0">
            <table :class="$style['goods-table']">
                <tr>
                    <td>商品名称</td>
                    <td>价格（元）</td>
                    <td v-if="showStockQuantity">库存（件）</td>
                </tr>
                <tr v-for="(item,index) in goods_list" :key="index">
                    <td>{{item.goodsDTO&&item.goodsDTO.goodsData&&item.goodsDTO.goodsData.name}}</td>
                    <td>{{item.final_price}}</td>
                    <td v-if="showStockQuantity">{{item.goodsOtherInfoDTO&&item.goodsOtherInfoDTO.stockQuantity}}</td>
                </tr>
            </table>
            </div>
        </pt-form-list-item>
        </template>
         <!-- <pt-form-list-item label="专属标签:">
            <wt-selector :class="$style['select-lab']"></wt-selector>
        </pt-form-list-item> -->
        <pt-form-list-item label="卡劵标题：" :required="true">
            <wt-input :class="$style['coupon-table-name']" v-model="formValue.couponData.title" data-vv-as="卡劵标题" name="name" v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="卡劵副标题：">
            <wt-input :class="$style['coupon-table-name']" v-model="formValue.couponData.subtitle"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="有效期设置：" :required="true">
            <pt-time-slot @change="validity_time" :startTime="formValue.couponData.startTime" :endTime="formValue.couponData.endTime"  type="datetime" :defaultTime="defaultTime"></pt-time-slot>
        </pt-form-list-item>
        <pt-form-list-item label="使用说明：" :required="true">
            <wt-ueditor :class="$style['policy-form-ueditor']" resource="" ref="ueditor" v-model="formValue.couponData.instruction " :content="content" data-vv-as="使用说明" name="name"  v-validate="'required'"></wt-ueditor>
            <!-- <wt-input v-model="formValue.couponData.instruction " data-vv-as="使用说明" v-validate="'required'"  type="textarea" rows='4' :autosize="{ minRows: 4, maxRows: 4}" :class="$style['coupon-table-name']"></wt-input> -->
        </pt-form-list-item>
          <pt-form-list-item label="上传第三方兑换码列表：" :required="true" v-if="isOffLine">
          <pt-upload-big-file resourceConfig="coupon_code" v-model="formValue.excel" data-vv-as="上传第三方兑换码列表" v-validate="'required'" @isUpload="isUpload" :isPathUrlAddTime="true"></pt-upload-big-file>
          <a :href="$privateResourcesUrlDownload+'templates/第三方兑换码上传模板.xlsx'" :class="$style['download-demo']">
            <el-button type="text">下载文件模版</el-button>
            </a>
        </pt-form-list-item>
        <pt-form-list-item label="适用地区：" :required="true" v-if="isOffLine">
            <wt-radio :radios="usedRegion" data-vv-as="适用地区" v-validate="'required'" v-model="formValue.couponData.nationalUse"></wt-radio>
        </pt-form-list-item>
        <pt-form-list-item label="选择地区：" :required="true" v-if="!formValue.couponData.nationalUse && isOffLine">
           <!-- <pt-address-select v-model="formValue.addressDetails" required clearable  data-vv-as="选择地区" name="name"
              v-validate="'required'" ref="address" :validateText="addressValidateText" :showElement="addressShowElement"></pt-address-select> -->
            <wt-selector :options="provincesList" v-model="addressDetails"  :props="provinceProps" data-vv-as="地区" name="name" v-validate="'required'" :multiple="true"></wt-selector>
        </pt-form-list-item>
    </table>
     <pt-sub-title title="发放/领取设置"></pt-sub-title>
     <table :class="$style['coupon-form-table']">
         <pt-form-list-item label="发放方式：" :required="true">
             <wt-radio :radios="publishTypeLabels" v-model="formValue.grantType" v-validate="'required'" data-vv-as="发放方式" :class="$style['grant-type']"></wt-radio>
         </pt-form-list-item>
         <pt-form-list-item label="发放对象：" v-if="canSpecifyUsers" :required="true">
             <wt-radio :radios="issueObj?publishOfflineObj:publishObj" v-model="formValue.grantObject" v-validate="'required'" data-vv-as="发放对象" :class="$style['grant-type']"></wt-radio>
         </pt-form-list-item>
         <pt-form-list-item v-if="formValue.grantObject=='DESIGNATED_USER' && canSpecifyUsers" label="选择用户：" :required="true">
             <select-user-fitter fromPage="promotion-form" :showBetchSelectUser="true" :selectedUserIdsList="selectedUserIdsList"
             :selectedUserList="selectUserList" @userSubmit="userSubmit" :disableSelect="disableSelect"  @importLoading="importLoading"
              :mallUserCriteria="mallUserCriteria">
             </select-user-fitter>
             <!-- <template>
                <el-button type="primary" @click="selectUser">点击选择</el-button>
                <div :class="$style['select-user-name']" v-if="selectUserList&&selectUserList.length">
                    <span>已选择 {{firstUserName}} {{selectUserList.length > 1 ? ('等'  +selectUserList.length +'位用户...') : ''}}</span>
                    <el-button type="text" @click="view_user">查看</el-button>
                </div>
             </template> -->
         </pt-form-list-item>
         <pt-form-list-item v-if="formValue.grantObject=='MEET_CONDITIONS_USER'&&canSpecifyUsers" label="邀新达标人数：" :required="true">
             <div :class="$style['register-number-text']">成功邀请
             <wt-input :class="$style['register-number']" type="number" v-model="formValue.inviteNumber" v-validate="'required|numeric|min_value:1'" data-vv-as="成功邀请人数"></wt-input>人注册为新用户
             </div>
         </pt-form-list-item>
        <pt-form-list-item label="发放总量：" :required="true" v-if="needAmount && !needAmountOffline">
            <wt-input data-vv-as="发放总量" name="name" type="number"  v-validate="'required|numeric|min_value:1'" v-model="formValue.amount"  :class="$style['coupon-table-name']"></wt-input>
        </pt-form-list-item>
     </table>
    <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog" :class="(is_select_user||is_view_user)?'user-dialog':(is_select_goods?'goods-dialog':'')">
        <coupon-for-goods @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" v-if="is_select_goods" :selected-goods="goods_list" :group-list="groupList"
        :params="goodsParams" :isFiledDisable="true"  :disableArr="disableOfGoods"></coupon-for-goods>
    </el-dialog>
  </div>
</template>

<script>
import ptUploadBigFile from 'cps/base/pt-upload-big-file'
import formMixins from 'mixins/form'
import { cashCount } from '@/utils/formUtils'
import { couponTypeHasLimit } from 'json/mall-options'
import { discountTypes, publishTypeLabels, publishObj, publishOfflineObj, goodsBelongLabel, getGoodsBelongLabel, formatAllGoodsBelong, usedType, usedRegion
} from '../promotion-option'
// import ptAddressSelect from 'cps/base/pt-address-select/withData'
import couponForGoods from '../../select-for-goods'
import selectUserFitter from 'cps/base/select-user-fitter/index'
// 组件class前缀
const prefixCls = 'pt-coupon-form'

export default {
  name: 'pt-coupon-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    couponData () {
      return this.formValue.couponData || {}
    },
    is_dialog: {
      get: function () {
        return this.is_select_goods || this.is_select_user || this.is_view_user
      },
      set: function (val) {
        this.is_select_goods = val
        this.is_select_user = val
        this.is_view_user = val
      }
    },
    needAmount () {
      return couponTypeHasLimit(this.formValue)
    },
    currentGoodsBelong () {
      return getGoodsBelongLabel(this.couponBelong)
    },
    allGoodsNotice () {
      return '如果您不选择任何商品，则默认为' + formatAllGoodsBelong(this.couponBelong)
    },
    currentDiscountLabel () {
      return this.formValue.couponData.discountType === 'FIXED_AMOUNT' ? '优惠减免' : '优惠折扣'
    },
    canSpecifyUsers () {
      return this.formValue.grantType === 'GRANT' || this.formValue.grantType === 'RECEIVE'
    },
    canSelectGoods () {
      // 除了全部商品，其他都可以选择商品
      return this.couponBelong !== 'ALL'
    },
    // 是否线下优惠券
    isOffLine () {
      return this.formValue.couponData.usedType === 'OFFLINE'
    },
    issueObj () {
      return this.isOffLine && this.formValue.grantType === 'GRANT'
    },
    // 是否显示适用商品选择
    needSelectGoods () {
      return !this.isOffLine
    },
    // 是否显示发放数量（线下优惠券发放数量）
    needAmountOffline () {
      return this.isOffLine
    }
  },
  props: {
    form: {
      type: Object,
      default: function () {
        return {}
      }
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    provincesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    couponForGoods,
    selectUserFitter,
    ptUploadBigFile
    // ptAddressSelect
  },
  data () {
    return {
      defaultTime: '23:59:59',
      formValue: {
        couponData: {}
      },
      couponBelong: this.getCouponBelong(),
      couponDiscount: this.getDiscount(),
      discountTypes: discountTypes,
      is_select_goods: false,
      dialog_title: '',
      goods_list: [],
      publishTypeLabels: publishTypeLabels,
      publishObj: publishObj,
      publishOfflineObj: publishOfflineObj,
      is_select_user: false,
      selectedUsersMessage: '',
      selectUserList: [],
      goodsBelongLabel: goodsBelongLabel,
      usedType: usedType,
      usedRegion: usedRegion,
      firstUserName: '',
      is_view_user: false,
      goodsParams: {},
      disableOfGoods: [],
      showStockQuantity: false,
      disableSelect: false,
      selectedUserIdsList: [],
      customerLoading: false,
      content: '',
      provinceProps: {
        label: 'province',
        value: 'value'
      },
      addressDetails: [],
      mallUserCriteria: {}
    }
  },
  watch: {
    needSelectGoods (val) {
      if (!val) {
        this.couponBelong = null
      } else {
        this.couponBelong = 'ALL'
      }
    },
    needAmountOffline (val) {
      if (!this.needAmount && !val) {
        this.formValue.amount = null
      }
    },
    'formValue.grantType' (val) {
      if (!this.canSpecifyUsers) {
        this.$delete(this.formValue, 'grantObject')
      }
    },
    addressDetails: {
      handler: function (val) {
        if (val) {
          let currentAddress = []
          for (let i = 0; i < val.length; i++) {
            currentAddress.push(JSON.parse(val[i]))
          }
          this.formValue.couponData.addressDetails = currentAddress
        }
      },
      deep: true
    },
    couponBelong: {
      handler: function (val) {
        this.setCouponBelong(val)
        this.goods_list = []
      }
    },
    couponDiscount: {
      handler: function (val) {
        this.formValue.couponData.discount = cashCount(val, false)
      }
    },
    canSelectGoods: {
      handler: function (val) {
        if (!val) {
          // 清空商品选择
          this.goods_list = null
          this.formValue.couponData.goodsIds = null
        }
      }
    },
    'formValue.nationalUse': {
      handler: function (val) {
        if (val) {
          this.formValue.addressDetails = []
        }
      },
      deep: true
    },
    form: {
      handler: function (val) {
        if (val) {
          console.log('-----form-------', JSON.stringify(val))
          this.formValue = this.isEdit ? this.currentForm(val) : { couponData: {} }
          this.couponBelong = this.getCouponBelong()
        }
      },
      deep: true
    },
    goods_list: {
      handler: function (val) {
        if (val && val.length > 0) {
          this.formValue.couponData.goodsIds = this.formValue.goodsIds || []
          //   this.formValue.goodsIds = this.formValue.goodsIds || []
          val.forEach(item => {
            this.formValue.couponData.goodsIds.push(item.goodsDTO.goodsData.goodsId)
          })
        }
      },
      deep: true
    }
  },
  methods: {
    currentForm (val) {
      let changeForm = JSON.parse(JSON.stringify(val))
      this.couponDiscount = this.getDiscount()
      let couponData = changeForm.couponData
      couponData.goodsIds = val.couponData.goodsIds || []
      this.content = couponData.instruction
      // this.formValue.excel = val.codeExcel
      // this.$set(changeForm, 'excel', changeForm.codeExcel)
      this.goods_list = (this.goods_list && this.goods_list.length > 0) ? this.goods_list : val.couponData.goodsInfo
      this.firstUserName = val.designatedUserName
      this.mallUserCriteria = val.mallUserCriteria && JSON.parse(JSON.stringify(val.mallUserCriteria))
      this.selectUserList = val.designatedUserInfo && JSON.parse(JSON.stringify(val.designatedUserInfo))
      if (couponData.addressDetails) {
        for (let i = 0; i < couponData.addressDetails.length; i++) {
          let value = {
            provinceGbCode: Number(couponData.addressDetails[i].provinceGbCode),
            provinceName: couponData.addressDetails[i].provinceName
          }
          this.addressDetails.push(JSON.stringify(value))
        }
      }

      // this.selectedUserIdsList = val.designatedUserIds && JSON.parse(JSON.stringify(val.designatedUserIds))
      return changeForm
    },
    isUpload (val) {
      this.$emit('isUpload', val)
    },
    importLoading (val) {
      this.customerLoading = val
    },
    userSubmit (val) {
      if (val && val.userListId) {
        this.disableSelect = true
        // if (this.formValue.designatedUserIds) {
        //   this.$delete(this.formValue, 'designatedUserIds')
        // }
        // let mallUserCriteria = {
        //   mallUserCriteria: {
        //     whiteList: [
        //       {
        //         userListId: val.userListId
        //       }
        //     ]

        //   }
        // }
        this.formValue = { ...this.formValue, ...val }
        this.$delete(this.formValue, 'userListId')
      } else {
        this.formValue = { ...this.formValue, ...val }
      }

      // if (val.userIds) {
      //   this.formValue.designatedUserIds = val.userIds
      //   this.$delete(this.formValue, 'userIds')
      // }
    },
    closeDialog () {
      this.is_select_goods = false
      this.is_select_user = false
      this.is_view_user = false
    },
    selectGoodsSubmit (val) {
      this.is_select_goods = false
      this.goods_list = val
    },
    validity_time (val) {
      this.formValue.couponData.startTime = val.startTime
      this.formValue.couponData.endTime = val.endTime
    },
    selectGoods () {
      if (this.couponBelong !== 'ALL') {
        this.goodsParams.goodsBelong = this.couponBelong
        this.disableOfGoods.push('goodsBelong')
      }
      this.is_select_goods = true
      this.dialog_title = '选择商品'
    },
    getCouponBelong () {
      let couponData = this.formValue && this.formValue.couponData
      if (couponData && couponData.couponBelong && couponData.couponBelong.length > 0) {
        return couponData.couponBelong[0]
      } else {
        if (couponData) {
          this.setCouponBelong('ALL')
        }
        return 'ALL'
      }
    },
    setCouponBelong (val) {
      if (!this.formValue.couponData.couponBelong) {
        this.formValue.couponData.couponBelong = []
        this.formValue.couponData.couponBelong.push(val)
      } else {
        this.formValue.couponData.couponBelong[0] = val
      }
    },
    getDiscount () {
      let couponData = this.form && this.form.couponData
      console.log('---------getDiscount-----', couponData, this.formValue)
      return couponData && cashCount(couponData.discount, true)
    }
  },
  created () {
    this.showStockQuantity = this.$store.getters.showStockQuantity
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.grant-type{
  :global
  .el-radio-group{
    label{
      line-height: 0.4rem
    }
  }
}
.coupon-form-table{
    :global
    .el-dialog__header{
       .el-dialog__title{
           font-weight: 600
       }
    };
    padding: 0 20px;
    :global
    tr{
        td:first-child{
          width: 1.5rem;
        }
    }
    :global
    .el-radio-group{
        line-height: 40px;
    }
}
.goods-table{
     display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.coupon-table-name{
    max-width: 260px;
}
.number-input-price{
    max-width: 200px;
    // margin: 10px 0
}
.select-concessions-button{
    margin-bottom: 5px;
}
.carpet-content{
    display: flex;
    line-height: 40px;
    .coupon-table-name{
        padding: 0 5px;
        max-width:100px;
        box-sizing: border-box
    }
}
.select-lab{
    margin-bottom: 5px;
    width: 260px;
}
.register-number{
    margin: 0 10px;
}
.register-number-text{
    display: flex;
    line-height: 40px;
}
:global
.user-dialog{
    .el-dialog{
        width: 70%;
        min-width: 1100PX;
        max-width:1200Px;
    }
    .el-dialog__body{
     padding: 0 20px 30px;
    }
}
.select-user-name{
    line-height: 40px;
    margin-top: 20px;
    :global
    .el-button--text{
        margin-left: 10px;
    }
}
:global
.goods-dialog{
   :global
    .el-dialog{
        width: 70%;
        max-width: 1000px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
</style>
